import { useState } from 'react';
import Swal from 'sweetalert2';
import { syncMasiva, syncIndividual } from '../../api/common';

const useClientes = () => {
  const [syncMasivaLoading, setSyncMasivaLoading] = useState(false);
  const [syncIndividualLoading, setSyncIndividualLoading] = useState(null);

  const handleSyncMasiva = async (refreshCallback) => {
    const confirm = await Swal.fire({
      title: '¿Sincronizar todos los clientes?',
      text: 'Se importarán los contactos desde el software contable configurado.',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sí, sincronizar',
      cancelButtonText: 'Cancelar',
    });

    if (!confirm.isConfirmed) return;

    setSyncMasivaLoading(true);
    try {
      const res = await syncMasiva();
      const data = res.data?.data || res.data || {};
      await Swal.fire({
        title: 'Sincronización completada',
        html: `
          <p><b>Procesados:</b> ${data.total_procesados || 0}</p>
          <p><b>Creados:</b> ${data.creados || 0}</p>
          <p><b>Actualizados:</b> ${data.actualizados || 0}</p>
          <p><b>Errores:</b> ${data.errores || 0}</p>
        `,
        icon: data.errores > 0 ? 'warning' : 'success',
      });
      if (refreshCallback) refreshCallback();
    } catch (err) {
      const msg = err.response?.data?.message || err.response?.data?.errors?.join(', ') || err.message;
      Swal.fire('Error', msg, 'error');
    } finally {
      setSyncMasivaLoading(false);
    }
  };

  const handleSyncIndividual = async (usuarioId, refreshCallback) => {
    setSyncIndividualLoading(usuarioId);
    try {
      const res = await syncIndividual(usuarioId);
      const msg = res.data?.message || 'Cliente sincronizado';
      Swal.fire({ title: msg, icon: 'success', toast: true, position: 'top-end', timer: 3000, showConfirmButton: false });
      if (refreshCallback) refreshCallback();
    } catch (err) {
      const msg = err.response?.data?.message || err.response?.data?.errors?.join(', ') || err.message;
      Swal.fire('Error', msg, 'error');
    } finally {
      setSyncIndividualLoading(null);
    }
  };

  return { syncMasivaLoading, syncIndividualLoading, handleSyncMasiva, handleSyncIndividual };
};

export default useClientes;
